<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.41602 10.083H8.24935V11.9163H6.41602V10.083ZM6.41602 13.7497H8.24935V15.583H6.41602V13.7497ZM10.0827 10.083H11.916V11.9163H10.0827V10.083ZM10.0827 13.7497H11.916V15.583H10.0827V13.7497ZM13.7493 10.083H15.5827V11.9163H13.7493V10.083ZM13.7493 13.7497H15.5827V15.583H13.7493V13.7497Z"
            fill="#22303E" fill-opacity="0.9" />
        <path
            d="M4.58333 20.1663H17.4167C18.4278 20.1663 19.25 19.3441 19.25 18.333V5.49967C19.25 4.48859 18.4278 3.66634 17.4167 3.66634H15.5833V1.83301H13.75V3.66634H8.25V1.83301H6.41667V3.66634H4.58333C3.57225 3.66634 2.75 4.48859 2.75 5.49967V18.333C2.75 19.3441 3.57225 20.1663 4.58333 20.1663ZM17.4167 7.33301L17.4176 18.333H4.58333V7.33301H17.4167Z"
            fill="#22303E" fill-opacity="0.9" />
    </svg>

</template>